<script lang="ts">
  //eslint-disable-next-line
  type ProductListItem = $$Generic;
  export let products: ProductListItem[];

  const breakpoints = {
    default: '100%',
    md: '768px',
  };
</script>

<div class="wrapper-container mb-12 w-full">
  <div class="grid grid-cols-1 gap-x-6 gap-y-8 md:grid-cols-2">
    {#each products as product}
      <div class="h-full break-inside-avoid">
        <slot {product} {breakpoints} />
      </div>
    {/each}
  </div>
</div>
